import { useContext } from 'react';
import { TransitionContext } from '../app/index';

function useRouteTransition() {
  return useContext(TransitionContext);
}

export default useRouteTransition;
